import styled from 'styled-components';
import {alignCenter, dFlex, dFlexColumn, justifyBetween} from '../../../../globalVariables/GlobalFlex';
import {StatusColor, statusStripPalette} from '../../StatusLabel/StatusLabel.css';

export const status = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    gap: var(--space-sm);
`;

export const caption = styled.span`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
`;

const pillLabelColor: Record<StatusColor, string> = {
    brand: 'var(--primitive-turquoise-700)',
    highlight: 'var(--color-text-default)',
    scanned: 'var(--color-state-warning-main)',
};

export const pill = styled.span<{$color: StatusColor}>`
    ${dFlex}
    ${alignCenter}
    justify-content: center;
    gap: var(--space-sm);
    width: auto;
    height: 44px;
    padding: 0 var(--space-xl);
    border-radius: var(--border-radius-border-radius-full);
    overflow: hidden;
    background: ${({$color}) => statusStripPalette[$color].bg};
    box-shadow: none;
`;

export const label = styled.span<{$color: StatusColor}>`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-semibold);
    line-height: var(--line-height-body-small);
    color: ${({$color}) => pillLabelColor[$color]};
    transform: translateX(calc(var(--space-xs) * -1.5));
    white-space: nowrap;
`;

export const icon = styled.img`
    display: block;
    width: 60px;
    height: 60px;
    flex: none;
    object-fit: contain;
    position: relative;
    top: var(--space-xs);
`;

export const scanInfo = styled.div`
    ${dFlexColumn}
    gap: var(--space-sm);
    width: 100%;
    max-width: 260px;
`;

export const scanRow = styled.div`
    ${dFlex}
    ${justifyBetween}
    align-items: baseline;
    gap: var(--space-lg);
    font-size: var(--font-size-body);

    span:first-child {
        color: var(--color-text-subtle);
    }

    span:last-child {
        font-weight: var(--font-weight-medium);
        color: var(--color-text-default);
    }
`;
